import React, { useState } from 'react';
import '../Header/Header.css';
import logo1 from '../../assets/salaiban logo 1.png'
const Header = () => {
  const [isNavVisible, setNavVisible] = useState(false);

  const toggleNavbar = () => {
    setNavVisible(!isNavVisible);
  };

  // const notificationText = (
  //   <>
  //     Applications for Shashwat Shramsanskar Camp (6-12 May 2025) are now open!{" "}
  //     <a href="https://docs.google.com/forms/d/e/1FAIpQLSeh6U2bvU2N_ogJYIn0jX4qyhyjiBqfuEhOthiUMt6u9U-KQQ/viewform?pli=1" target="_blank" rel="noopener noreferrer" className="register-link">
  //       Register Here
  //     </a>. For more details, please contact us at 9325777609.
  //   </>
  // );

   const notificationText = (
    <>
      Applications for RanBhaji Utssav (16 August 20226) are now open! For more details, please contact us at 9422129116.
    </>
  );
  
  return (
    <>
    <div className="notification-bar">
      <span className="notification-label">Notification</span>
      <div className="notification-text">
        <div className="scrolling-text">
          {notificationText}
        </div>
      </div>
    </div>

    <header className='header'>
      <div className='logo'>
        <img src={logo1} alt='Salaiban' />
      </div>
      <nav className='navbar'>
        <button className='navbar-toggle' id='navbarToggle' onClick={toggleNavbar}>
          &#9776;
        </button>
        <ul className={`navbar-links ${isNavVisible ? 'show' : ''}`} id='navbarLinks'>
          <li><a href="/home">Home</a></li>
          <li><a href="/projects">Initiatives</a></li>
          <li><a href="/gallery">Gallery</a></li>
          <li><a href="/about">About Us</a></li>
          <li><a href="/donate">Donate</a></li>
        </ul>
      </nav>
    </header>
    </>
  );
};

export default Header;
